/* eslint-disable */
import axios from 'axios';
import store from "../../store/index";
import TaskListModal from '../TaskListPopup/TaskListModal.vue';
import moment from "moment";
import manageRiskRegisterModal from "../ManageRiskRegisterModal/ManageRiskRegisterModal.vue";

export default{
    name: 'riskRegister',
    components: {
        TaskListModal,
        manageRiskRegisterModal
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            showMoreMitigation:{},
            studyId : "",
            showRiskRegisterModal: false,
            idToken : store.getters.getIdToken,
            headerValues: {},
            selectedcolumnobj: {},
            selectedColumns: [],
            getColumns: [],
            showFilter:false,
            dropdownOpen:false,
            riskId :"",
            riskName: "",
            mitigationPlan: "",
            responsibleOwner: "",
            expectedOutcome: "",
            resourceNeed: "",
            evidenceUpload:"",
            status: "",
            closedDate: "",
            closedUserEmail: "",
            resolvedDate: "",
            lessonLearned: "",
            comments: "",
            dataScope: "",
            criticalDataPoints: [],
            showTableLoader: false,
            showCriricalPopUp: false,
            selectedCriticalDP: {},
            defaultdate: "",
            defaultTime: "",
        };
    },
    async mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        this.defaultTime = localStorage.getItem("timeformat");
        this.filter();
        this.idtoken = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        console.log('CriticalDataInventory component mounted');
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.studyId = event.detail.storage;
            this.getCriticalProcess();
            this.initializeColumns();
        });
        await  this.getCriticalProcess();
        this.initializeColumns();
    },
    methods: {
         filter(date) {
              if (date) {
                return moment(date).format(this.defaultdate)
              }
            },
            toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
    initializeColumns() {
      if (this.criticalDataPoints.length > 0) {
        const allowedKeys = [
          "riskId",
          "riskName",
          "mitigationPlan",
          "responsibleOwner",
          "expectedOutcome",
          "resourceNeed",
          "evidenceUpload",
          "status",
          "closedDate",
          "closedUserEmail",
          "resolvedDate",
          "lessonLearned",
          "comments",
          "dataScope",
          "derivedfrom",
          "dateidentified",
          "identifiedby"
        ];
        this.getColumns = Object.keys(this.criticalDataPoints[0]).filter((column) =>
          allowedKeys.includes(column)
        );
        const fieldLabels = {
          riskId: "Risk Register ID",
          riskName: "Risk Indicator",
          mitigationPlan: "Mitigation Plan",
          responsibleOwner: "Responsible Owner",
          expectedOutcome: "Expected Outcome",
          resourceNeed: "Resource Need",
          evidenceUpload: "Evidence Upload",
          status: "Status",
          closedDate: "Closed Date",
          closedUserEmail: "Closed By",
          resolvedDate: "Resolved Date",
          lessonLearned: "Lesson Learned",
          comments: "Comments",
          dataScope: "Data Scope",
          derivedfrom: "Derived From",
          dateidentified: "Date Identified",
          identifiedby: "Identified By",
          
        };
 
        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        const initiallyTrueKeys = ["Risk Register ID","Risk Indicator","Responsible Owner","Status","Closed Date","Closed By","Derived From","Date Identified","Identified By"];

        this.getColumns = readableData;
        this.selectedColumns = initiallyTrueKeys;
        this.selectedcolumnobj = this.getColumns.reduce((obj, key) => {
          obj[key] =initiallyTrueKeys.includes(key);
          return obj;
        }, {});
        console.log("object", this.selectedColumns);
      }
    },
    async closeRiskReg() {
        this.showRiskRegisterModal = false;
        this.getCriticalProcess();
      },
      async CreateRiskClicked(regisId) {
        if(regisId == "0"){
            await this.addRiskRegister(regisId);
        }else{
            this.riskRegisterId = regisId;
        }
        this.showRiskRegisterModal = true;
      },
      async addRiskRegister(riskScoreID) {
              const idtoken = store.getters.getIdToken;
              try {
                  const res = await axios.post(
                  `${this.baseurl}/forms/riskregister/createriskregister`,
                  { "riskScoreId": riskScoreID },
                  {
                      headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                      },
                  }
                  );
                  console.log("created...........", res.data);
                  this.riskRegisterId = res.data;
                  } catch (err) {
                      console.log("error in adding risk register", err);
                  }
              },
        async getCriticalProcess(){
            try{
                var res = await axios.get(`${this.baseurl}/forms/riskregister/getriskregisterdetails?studyId=${this.studyId}&riskName=${this.riskName}&riskId=${this.riskId}&status=${this.status}&dataScope=${this.dataScope}`, this.headerValues);
                console.log("Critical Data Points:", res.data.entities);
                this.criticalDataPoints = res.data.entities;
            }
            catch (error) {
                console.error("Error fetching critical data points:", error);
            }
        },
        async showCriticalDP(CriticalDP){
            console.log("Critical Data Point clicked:", CriticalDP);
            this.showCriricalPopUp = true;
            this.selectedCriticalDP = CriticalDP;
        },
        async closeCriticalDataPopup() {
            this.showCriricalPopUp = false;
            this.selectedCriticalDP = {};
        }
    },
   

}